import { render } from "./SlideNav.vue?vue&type=template&id=3abb5dc5&scoped=true"
import script from "./SlideNav.vue?vue&type=script&lang=js"
export * from "./SlideNav.vue?vue&type=script&lang=js"

import "./SlideNav.vue?vue&type=style&index=0&id=3abb5dc5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abb5dc5"]])

export default __exports__